import { render } from "./GameList.vue?vue&type=template&id=0bd59bfd"
import script from "./GameList.vue?vue&type=script&lang=js"
export * from "./GameList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\game-forecast\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__